import { rest } from "msw";
import { TaskType } from "~@/types/fake";

const getTasks = (pageSize:number)=>{
    return (JSON.parse(localStorage.getItem('tasks') || '[]') )
}

export const taskhandler = rest.get("/tasks", (req, res, ctx) => {
  const params = req.url.searchParams;
  const products = getTasks(Number(params.get("pageSize")))
  return res(
    ctx.status(200),
    ctx.json({
      data: {
        records: products,
        currentPage: Number(params.get("page")),
        pageSize: Number(params.get("pageSize")),
        totalPages: 1,
        totalSize: products.length,
      },
      errorCode: 200,
      message: "",
    })
  );
});


export const cancelTask = rest.post("/cancel-task", async (req, res, ctx) => {
    const textDecoder = new TextDecoder("utf-8");
    const buffer = await req.arrayBuffer()
    const body = JSON.parse(textDecoder.decode(buffer))
    const tasks = JSON.parse(localStorage.getItem("tasks")||'[]')
    console.log(body)
    console.log(tasks.filter((item:TaskType)=>item.id!==body.id))
    localStorage.setItem("tasks", JSON.stringify(tasks.filter((item:TaskType)=>item.id!==body.id)))
    return res(
      ctx.status(200),
      ctx.json({
        data: undefined,
        errorCode: 200,
        message: "操作成功",
      })
    );
})

